import { ApiGeneralItem, ApiGeneralResponse } from '../config/type';

export function normalizeRows(input: ApiGeneralResponse | ApiGeneralItem[] | null | undefined): ApiGeneralItem[] {
  if (!input) return [];
  if (Array.isArray(input)) return input;
  const d = (input as any).data ?? (input as any).rows ?? null;
  if (Array.isArray(d)) return d as ApiGeneralItem[];
  if (d) return [d as ApiGeneralItem];
  return [];
}
